import { Stack } from 'expo-router'

export const NotificationsLayout = () => <Stack screenOptions={{ headerShown: false }} />
